import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingAutoCorrectedSearchEvent implements GATrackingEvent {

  constructor(private searchTerm: string, private autoCorrectedTerm: string) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.AutoCorrectedSearch;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.SearchCorrected,
      label: this.getLabel()
    };
  }

  private getLabel(): string {
    const searchTerm = this.searchTerm ? this.searchTerm.toLowerCase() : '';
    const autoCorrectionTerm = this.autoCorrectedTerm ? this.autoCorrectedTerm.toLowerCase() : '';
    return `${searchTerm},${autoCorrectionTerm}`;
  }
}
